import React, { useState } from 'react';
import {
    TextField,
    Button,
    Grid,
    Alert,
    Avatar,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import axios from 'axios';

const RegisterClient = ({ setOpen, Clients }) => {
    const [clientData, setClientData] = useState({
        name: '',
        lastName: '',
        email: '',
        phone: '',
        type: '',
        birthDate: '',
        avatar: null,
    });

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [preview, setPreview] = useState('');
    const [uploadStatus, setUploadStatus] = useState('');
    const [edad, setEdad] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setClientData({ ...clientData, [name]: value });
    };

    const handleFileChange = (e) => {
        const { files } = e.target;
        if (files[0]) {
            setClientData({ ...clientData, avatar: files[0] });
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(files[0]);
        }
    };

    const calcularEdad = (fechaISO) => {
        const hoy = new Date();
        const nacimiento = new Date(fechaISO);
        let edad = hoy.getFullYear() - nacimiento.getFullYear();
        const mes = hoy.getMonth() - nacimiento.getMonth();

        if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
            edad--;
        }

        setEdad(edad);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setUploadStatus('');

        const formData = new FormData();
        formData.append('name', clientData.name);
        formData.append('lastName', clientData.lastName);
        formData.append('email', clientData.email);
        formData.append('phone', clientData.phone);
        formData.append('birthDate', clientData.birthDate);
        formData.append('type', clientData.type);
        if (clientData.avatar) {
            formData.append('avatar', clientData.avatar);
        }

        try {
            const response = await axios.post('https://softwaregestion-production-b8ad.up.railway.app/api/register-client', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            setUploadStatus('¡Cliente registrado correctamente!');
            setClientData({
                name: '',
                lastName: '',
                email: '',
                phone: '',
                birthDate: '',  // Se restablece la fecha de nacimiento
                type: '',
                avatar: null,
            });
            setPreview('');
            setEdad(null); // Restablecer la edad también
            setOpen(true);

        } catch (err) {
            setOpen(true);
            setUploadStatus('');
            setError(err.response ? err.response.data.message : 'Error al registrar el cliente');
        } finally {
            Clients();
            setLoading(false);
        }
    };

    return (
        <Grid container justifyContent="center" spacing={3}>
            <Grid item>
                <form onSubmit={handleSubmit}>
                    <Stack direction="column" spacing={1} alignItems="center" sx={{ mb: 2 }}>
                        <input
                            accept="image/*"
                            type="file"
                            id="avatar-upload"
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />
                        <label htmlFor="avatar-upload" style={{ position: 'relative' }}>
                            <Avatar
                                src={preview}
                                sx={{ width: 100, height: 100 }}
                            />
                            <IconButton
                                component="span"
                                sx={{
                                    position: 'absolute',
                                    bottom: 0,
                                    right: 0,
                                    backgroundColor: '#fff',
                                    border: '1px solid #ccc',
                                }}
                            >
                                <PhotoCamera />
                            </IconButton>
                        </label>
                        <Typography variant="caption" color="textSecondary">
                            Selecciona una imagen de perfil
                        </Typography>
                    </Stack>

                    <TextField
                        label="Nombres"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="name"
                        value={clientData.name}
                        onChange={handleChange}
                        required
                    />
                    <TextField
                        label="Apellidos"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="lastName"
                        value={clientData.lastName}
                        onChange={handleChange}
                        required
                    />
                    <TextField
                        label="Correo Electrónico"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="email"
                        type="email"
                        value={clientData.email}
                        onChange={handleChange}
                        required
                    />
                    <TextField
                        label="Teléfono"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="phone"
                        value={clientData.phone}
                        onChange={handleChange}
                        required
                    />
             {/*        <TextField
                        label="Fecha de Nacimiento (opcional)"
                        type="date"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="birthDate"
                        value={clientData.birthDate}  // Asegurarse de que el valor se actualiza con cada cambio
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ lang: 'es' }}
                    /> */}

                    {uploadStatus && (
                        <Alert severity="success" sx={{ mt: 2 }}>
                            {uploadStatus}
                        </Alert>
                    )}

                    {error && (
                        <Alert severity="error" sx={{ mt: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={loading}
                        sx={{ marginTop: 2 }}
                    >
                        {loading ? 'Registrando...' : 'Registrar Cliente'}
                    </Button>
                </form>
            </Grid>
        </Grid>
    );
};

export default RegisterClient;
